import { InlineSVGStyled } from './Icon.styled';

type IconPropsObligatoryT = {
  fileName: string;
};

export type IconPropsOptionalT = {
  width?: string;
  height?: string;
  color?: string;
};

export const Icon: React.SFC<IconPropsObligatoryT & IconPropsOptionalT> = props => {
  const { width, height, color, fileName } = props;

  return (
    <InlineSVGStyled
      src={`/images/icons/${fileName}.svg`}
      width={width}
      height={height}
      color={color}
    />
  );
};

export default Icon;

export const BurgerIcon = (props: IconPropsOptionalT) => <Icon fileName="burger" {...props} />;

export const CloseIcon = (props: IconPropsOptionalT) => <Icon fileName="close" {...props} />;

export const InfoIcon = (props: IconPropsOptionalT) => <Icon fileName="info" {...props} />;

export const QuestionBubbleIcon = (props: IconPropsOptionalT) => (
  <Icon fileName="question-bubble" {...props} />
);

export const LeftChevronIcon = (props: IconPropsOptionalT) => (
  <Icon fileName="left-chevron" width="10px" height="20px" {...props} />
);

export const ArrowLeftIcon = (props: IconPropsOptionalT) => (
  <Icon fileName="arrow-left" {...props} />
);

export const TrashIcon = (props: IconPropsOptionalT) => <Icon fileName="trash" {...props} />;

export const QuestionIcon = (props: IconPropsOptionalT) => (
  <Icon fileName="question" width="25px" height="25px" {...props} />
);

export const PlusCircleIcon = (props: IconPropsOptionalT) => (
  <Icon fileName="plus-circle" {...props} />
);

export const SearchIcon = (props: IconPropsOptionalT) => <Icon fileName="search" {...props} />;

export const EllipsisIcon = (props: IconPropsOptionalT) => (
  <Icon fileName="ellipsis" width="8px" {...props} />
);

export const TextIcon = (props: IconPropsOptionalT) => <Icon fileName="text" {...props} />;

export const ShareIcon = (props: IconPropsOptionalT) => <Icon fileName="share" {...props} />;

export const DownloadIcon = (props: IconPropsOptionalT) => <Icon fileName="download" {...props} />;

export const PrintIcon = (props: IconPropsOptionalT) => <Icon fileName="print" {...props} />;

export const EditIcon = (props: IconPropsOptionalT) => (
  <Icon width="16px" height="16px" fileName="edit" {...props} />
);

export const UpArrowIcon = (props: IconPropsOptionalT) => <Icon fileName="up-arrow" {...props} />;
